<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue'
import { NumberUtils } from '~utils'

const props = defineProps({
  number: {
    type: Number,
    default: 0
  },
  suffix: {
    type: String,
    default: ''
  },
  start: {
    type: Number,
    default: 0
  }
})

const numberCounter = ref(NumberUtils.formatNumberWithCommas(props.start))
const animationDuration = 1000

const animateNumber = (start: number = 0): void => {
  let startTimestamp: number | null = null;
  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress: number = Math.min((timestamp - startTimestamp) / animationDuration, 1);
    numberCounter.value = NumberUtils.formatNumberWithCommas(Math.floor(progress * (props.number - start) + start));
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };
  requestAnimationFrame(step);
}

onMounted(() => {
  animateNumber()
})

watch(
  () => props.number,
  () => {
    animateNumber()
  }
)
</script>
<template>
  <span>
    {{ numberCounter }} <strong>{{ suffix }}</strong>
  </span>
</template>
